import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import './Slider.css';

import p1 from "../Assets/poster.jpeg";
import p2 from "../Assets/poster2.jpeg";
import p3 from "../Assets/poster3.jpeg";
import p4 from "../Assets/poster4.jpeg";
import p5 from "../Assets/poster5.jpeg";
import p6 from "../Assets/poster5.jpeg";

import { API_BASE } from '../../config/api';
const FALLBACK_CATEGORIES = [
  { name: 'BRASS-CZ-COLOR STONE', imageUrl: '' },
  { name: 'SILVER-PLAIN', imageUrl: '' },
  { name: 'SILVER-CZ-COLOR STONE', imageUrl: '' },
  { name: 'SILVER-CVD (LGD)', imageUrl: '' },
  { name: 'SILVER-NATURAL DIAMOND', imageUrl: '' },
  { name: 'GOLD-PLAIN', imageUrl: '' },
  { name: 'GOLD-CZ-COLOR STONE', imageUrl: '' },
  { name: 'GOLD-CVD (LGD)', imageUrl: '' },
  { name: 'GOLD-NATURAL DIAMOND', imageUrl: '' },
  { name: 'PLATINUM-PLAIN', imageUrl: '' },
  { name: 'PLATINUM-CVD (LGD)', imageUrl: '' },
  { name: 'PLATINUM-NATURAL DIAMOND', imageUrl: '' },
  { name: 'PLATINUM-GOLD-PLAIN', imageUrl: '' },
  { name: 'PLATINUM-GOLD-STUDDED (LGD/NATURAL)', imageUrl: '' },
];
const DEFAULT_IMAGES = [p1, p2, p3, p4, p5, p6];

const CategorySlider = () => {
  const [categories, setCategories] = useState(FALLBACK_CATEGORIES);

  useEffect(() => {
    fetch(`${API_BASE}/category-slider`)
      .then((res) => res.json())
      .then((data) => {
        const items = data?.items;
        if (Array.isArray(items) && items.length > 0) {
          setCategories(items);
        } else {
          setCategories(FALLBACK_CATEGORIES);
        }
      })
      .catch(() => setCategories(FALLBACK_CATEGORIES));
  }, []);

  const getImage = (item, idx) => {
    if (item?.imageUrl?.trim()) return item.imageUrl;
    return DEFAULT_IMAGES[idx % DEFAULT_IMAGES.length];
  };
  const navigate = useNavigate();

  const handleCategoryClick = (categoryName) => {
    navigate(`/store?material=${encodeURIComponent(categoryName)}`);
  };

  return (
    <div className="category-slider-container">
      <h2 className="category-heading">Shop by Category</h2>
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={10}
        slidesPerView={4}
        navigation
        autoplay={{
          delay: 1200,
          disableOnInteraction: false,
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 },
          480: { slidesPerView: 2, spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 25 },
        }}
      >
        {categories.map((cat, idx) => (
          <SwiperSlide key={idx}>
            <div 
              className="category-card" 
              onClick={() => handleCategoryClick(cat.name)}
              style={{ cursor: 'pointer' }}
            >
              <div className="category-image-wrapper">
                <img src={getImage(cat, idx)} alt={cat.name} className="category-image" />
              </div>
              <div className="category-name">{cat.name}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CategorySlider;
